import * as React from 'react';
import { Alert } from '@payscale/design';
import './invalidEmployeeDataAlert.scss';
import { observer } from 'mobx-react';

interface IInvalidEmployeeDataAlertProps {
    onNavClick: () => void;
}

export class InvalidEmployeeDataAlert extends React.Component<IInvalidEmployeeDataAlertProps> {
    constructor(props: IInvalidEmployeeDataAlertProps) {
        super(props);
        this.onReviewDataClick = this.onReviewDataClick.bind(this);
    }

    render(): React.ReactNode {
        return (
            <Alert
                className="nomst-invalid-employee-data-alert"
                message={this.renderAlertMessage()}
                level="warning"
                close={false}
            />
        );
    }

    private renderAlertMessage(): React.ReactNode {
        return (
            <div className="nomst-invalid-employee-data-alert__message-container">
                <div className="nomst-invalid-employee-data-alert__header">
                    Data in your Team account needs your attention
                </div>
                <div className="nomst-invalid-employee-data-alert__body">
                    To ensure the best Team experience for your managers, please review and update your data.
                </div>
                <button
                    className="nomst-invalid-employee-data-alert__review-data-button pxl-btn--primary"
                    onClick={this.onReviewDataClick}
                >
                    Review Data
                </button>
            </div>
        );
    }

    private onReviewDataClick(): void {
        this.props.onNavClick();
    }
}

export default observer(InvalidEmployeeDataAlert);